/**
 * Get uniba header slim configuration action
 * @module src/actions/getUnibaHeaderSlimConfig
 */
export const GET_UNIBA_HEADERSLIM_CONFIG = 'GET_UNIBA_HEADERSLIM_CONFIG';

/**
 * Get uniba header slim configuration.
 * @function getUnibaHeaderSlimConfig
 * @returns {Object} Get uniba header slim configuration action.
 */
export function getUnibaHeaderSlimConfig(params) {
  return {
    type: GET_UNIBA_HEADERSLIM_CONFIG,
    request: {
      op: 'get',
      path: `/@getHeaderSlimConfigurationUniba`,
      params: params,
    },
  };
}
